<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style src="@/vendor/styles/bootstrap.scss" lang="scss"></style>
<style src="@/vendor/styles/appwork.scss" lang="scss"></style>
<style src="@/vendor/styles/theme-corporate.scss" lang="scss"></style>
<style src="@/vendor/styles/colors.scss" lang="scss"></style>
<style src="@/vendor/styles/uikit.scss" lang="scss"></style>
<style src="./style.scss" lang="scss"></style>

<script>
import { getCookie, setHoursCookie } from '@/utils/cookieFunctions'
import { versionKontrol } from '@/api/version'

export default {
  name: 'app',
  metaInfo: {
    title: 'Index',
    titleTemplate: '%s - Kuran Öğren'
  },
  updated () {
    // Remove loading state
    setTimeout(() => document.body.classList.remove('app-loading'), 1)
  },
  async created () {
    var url = window.location.href
    if (url.includes('http://') && process.env.NODE_ENV !== 'development') {
      window.location = url.replace('http://', 'https://')
    }
    // await this.apidenversionKontrol()
  },
  methods: {
    async apidenversionKontrol () {
      try {
        const result = await versionKontrol()
        console.log('API Front-End Version', result.version)
        const localVersion = getCookie('frontend-version')
        console.log('Local Front-End Version', localVersion)
        if (!localVersion) {
          setHoursCookie('frontend-version', result.version, 8760)
          location.reload()
        }
        if (result.version !== localVersion) {
          setHoursCookie('frontend-version', result.version, 8760)
          location.reload()
        }
        console.log('Time', new Date())
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>
<style>
.toast-body {
  white-space: pre-line !important;
}

.bv-no-focus-ring {
  width: 100%;
}
</style>
